var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2315 30.5746L24.1667 44L36.1019 30.5746C45.2559 20.2776 37.9453 4 24.1667 4C10.3881 4 3.07751 20.2776 12.2315 30.5746Z",
    stroke: "#3C4043",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1667 26C27.4805 26 30.1667 23.3137 30.1667 20C30.1667 16.6863 27.4805 14 24.1667 14C20.853 14 18.1667 16.6863 18.1667 20C18.1667 23.3137 20.853 26 24.1667 26Z",
    stroke: "#3C4043",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.e3d079ff6cbce97ffe5ecbe7b4d42d8f.svg";
export { ForwardRef as ReactComponent };